import actions from '@/store/model/actions'
import model from './model'

export default actions(model)
